import React, { useState } from 'react';
import Header from './components/Header';
import Main from './components/Main';
import LeftContainer from './components/LeftContainer';
import RightContainer from './components/RightContainer';
import { Navigate } from 'react-router-dom';

function RequesterApp() {
  const [filteredEventDates, setFilteredEventDates] = useState([]);
  var role = localStorage.getItem('role');

  switch (role) {
    case 'Visit Requester':
    case 'Requester':
    case 'Admin':
      return (
        <div>
          <Header />
          <Main />
          <div className="container-fluid">
            <div className="progress d-flex flex-column" style={{ backgroundColor: 'gainsboro', height: '100%' }}>
              <div className="row">
                <div className="col-md-8">
                  <LeftContainer setFilteredEventDates={setFilteredEventDates} />
                </div>
                <div className="col-md-4">
                  <RightContainer eventDates={filteredEventDates} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    case 'MLTUser':
    case 'MLTCoordinator':
      return (
        <div>
          <Navigate to={`/AppMltEvent`} replace />
        </div>
      )
    case 'Family':
    case 'FamilyCoordinator':
      return (
        <div>
          <Navigate to={`/AppFamily`} replace />
        </div>
      )
    default:
      return (
        <div>
          <Navigate to="/" replace />
        </div>
      )
  }
}

export default RequesterApp;